import { Form, Formik, FormikProps } from 'formik';
import { FieldSelectRow } from '../../../components/FormComponents';
import { UpdatingOfferInput, paymentMethodOptions } from './UpdatingOfferFormData';

import './UpdatingOfferForm.css';
import { UpdateOfferValues } from './UpdatingOfferForm.types';

const SelectPaymentPeriod = ({ updateOfferValues, onSubmit, needSelection }: any) => {
  const inputData = UpdatingOfferInput[needSelection];

  return (
    <Formik initialValues={updateOfferValues} onSubmit={onSubmit}>
      {(formikForm: FormikProps<UpdateOfferValues>) => (
        <Form>
          <div className="updating-offer-form__container first-child">
            <FieldSelectRow
              name={inputData?.paymentMethod.key}
              label={inputData?.paymentMethod.text}
              value={formikForm.values.paymentMethod}
              placeholder=""
              onChange={form => {
                setTimeout(() => form.submitForm(), 0);
              }}
              options={paymentMethodOptions}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SelectPaymentPeriod;
